import { render, staticRenderFns } from "./vProteinQualityReport.vue?vue&type=template&id=75e13bdf&scoped=true"
import script from "./vProteinQualityReport.vue?vue&type=script&lang=ts"
export * from "./vProteinQualityReport.vue?vue&type=script&lang=ts"
import style0 from "./vProteinQualityReport.vue?vue&type=style&index=0&id=75e13bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e13bdf",
  null
  
)

export default component.exports